<ion-button fill="clear" (click)="openLanguageModal()">
  <div class="lang-flag">
    <ng-icon [name]="getFlagName(getCountryCode(languageService.currentLang()))" size="20"></ng-icon>
  </div>
  <ion-icon name="chevron-down-outline" slot="end"></ion-icon>
</ion-button>
